import { Button, Input, Form, Space, message } from "antd";
import {setPassword} from '../../requests/user';
import React, { useState, useContext } from "react";
import { useNavigate, useLocation } from 'react-router-dom';
import './SetPassword.scss';
import StoredUserContext from "../../context/StoredUserContext";

function ResetPassword(props) {

    const navigate = useNavigate();
  const [contextUser, setContextUser] = useContext(StoredUserContext);
    const [messageApi, contextHolder] = message.useMessage();
    const location = useLocation();
    const {user_id, token, reset_id} = location.state;
    const onFinish = async (values) => {
        if(values.password !== values.password2){
            messageApi.error('Password not match');
            return;
        }
        const res = await setPassword({user_id: user_id, token: token, password: values.password, reset_id: reset_id});
        if(res.result === 'success'){
            messageApi.success('Reset password failed');
            localStorage.setItem('user', JSON.stringify(res.user))
            setContextUser(res.user);
            navigate('/pre-home')
        }else{
            messageApi.error('Reset password failed');
            return;
        }
    };
    const onFinishFailed = (errorInfo) => {
        // messageApi.error('Send reset code error');
    };

    return (
        <div className='d-flex flex-column justify-content-center align-items-center' style={{ height: '100vh' }}>
            {contextHolder}
            <div className="reset-container">
                <Form
                    name="basic"
                    labelCol={{
                        span: 8,
                    }}
                    wrapperCol={{
                        span: 24,
                    }}
                    style={{
                        maxWidth: 600,
                    }}
                    initialValues={{
                        remember: true,
                    }}
                    layout='vertical'
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    autoComplete="off"
                >   
                <div style={{marginBottom: '30px'}}>
                    <h2 style={{fontWeight: 'bold'}}>Reset password</h2>
                    <br/>
                </div>
                    <Form.Item name={'password'} label="New Password" rules={[{ required: true, message: 'Please input your password!' }]}>
                            <Input.Password />
                    </Form.Item>
                    <Form.Item name={'password2'} label="Repeat New Password" rules={[{ required: true, message: 'Please input your password!' }]}>
                            <Input.Password />
                    </Form.Item>
                    <Form.Item
                        wrapperCol={{
                            span: 24,
                        }}
                    >
                        <Button type="primary" htmlType="submit" style={{width: '100%'}}>
                            Reset my password
                        </Button>
                    </Form.Item>
                </Form>
            </div>

        </div>
    );
}

export default ResetPassword